import * as types from './actionTypes';


export const get = (activityType, contactId) =>{
	return{
    type: types.WAGE_RATE_LIST_REQUEST,
    activityType,
    contactId
  }
};

export const getSuccess = data => {
	return {
		type: types.WAGE_RATE_LIST_SUCCESS,
		payLoad: {data, loading: false}
	};
};
export const getFailure = data => {
	return {
		type: types.WAGE_RATE_LIST_FAILURE,
		payLoad: {data, loading: false}
	};
};

export const getAll =(contactId) =>{
  return {
    type: types.WAGE_RATE_ALL_REQUEST,
    contactId
  }
};
export const getAllSuccess =(data) =>{
  return {
    type: types.WAGE_RATE_ALL_SUCCESS,
    payLoad:data
  }
};
export const getAllFailure =(data) =>{
  return {
    type: types.WAGE_RATE_ALL_FAILURE
  }
};

export const removeRequest = (contactId, id) =>{
	return{
    type: types.WAGE_RATE_REMOVE_REQUEST,
    id,
    contactId    
  }
};

export const removeSuccess = data => {
	return {
		type: types.WAGE_RATE_REMOVE_SUCCESS,
		payLoad: {data, loading: false}
	};
};
export const removeFailure = data => {
	return {
		type: types.WAGE_RATE_REMOVE_FAILURE,
		payLoad: {data, loading: false}
	};
};

export const storeRequest = (contactId, data) =>{
	return{
    type: types.WAGE_RATE_STORE_REQUEST,
    data,
    contactId
  }
};

export const storeSuccess = data => {
	return {
		type: types.WAGE_RATE_STORE_SUCCESS,
		payLoad: {data, loading: false}
	};
};
export const storeFailure = data => {
	return {
		type: types.WAGE_RATE_STORE_FAILURE,
		payLoad: {data, loading: false}
	};
};

export const updateRequest = (contactId, wageRateId, data ) =>{
	return{
    type: types.WAGE_RATE_NEW_UPDATE_REQUEST,
    data,
    contactId,    
    wageRateId
  }
};
export const updateSuccess = data => {
	return {
		type: types.WAGE_RATE_NEW_UPDATE_SUCCESS,
		payLoad: {data, loading: false}
	};
};
export const updateFailure = data => {
	return {
		type: types.WAGE_RATE_NEW_UPDATE_FAILURE,
		payLoad: {data, loading: false}
	};
};